const CategoriesPage = () => (
  <div>
    <h1> Under Construction </h1>
  </div>
);

export default CategoriesPage;
